import { EmbeddingService } from '@accredible-frontend-v2/embedding';
import { AccredibleCookiesService } from '@accredible-frontend-v2/services/cookies';
import { AccredibleWebSocketService } from '@accredible-frontend-v2/services/websocket';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DashboardStateKey } from '../../entities/db-state-keys.model';
import { WebSocketProgressMessage } from './ws-progress-channel.model';

@Injectable({
  providedIn: 'root',
})
export class WebSocketProgressChannelService {
  private readonly _cookies = inject(AccredibleCookiesService);
  private readonly _embedding = inject(EmbeddingService);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _message$ = new BehaviorSubject<WebSocketProgressMessage<unknown>>(null);

  message$ = this._message$.asObservable();

  private _webSocket: AccredibleWebSocketService;

  connect(): void {
    this._createWebSocket();
    this._webSocket
      .connect('Issuer::ProgressChannel')
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        map((messageEvent) => messageEvent.message as WebSocketProgressMessage<unknown>),
        catchError((error) => throwError(() => new Error(error))),
      )
      .subscribe((message) => {
        this._message$.next(message);
      });
  }

  resetMessage(): void {
    this._message$.next(null);
  }

  closeConnection(): void {
    this._message$.complete();
    this._webSocket.closeConnection();
  }

  private _createWebSocket(): void {
    const sessionToken = this._cookies.get(DashboardStateKey.SESSION_TOKEN_COOKIE);
    const departmentId = this._embedding.departmentId;
    if (!this._webSocket) {
      this._webSocket = new AccredibleWebSocketService(departmentId, sessionToken);
    }
  }
}
